import React, { useMemo, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Footer from "../components/Layout/Footer";
import Header from "../components/Layout/Header";
import Loader from "../components/Layout/Loader";
import ProductCard from "../components/Route/ProductCard/ProductCard";
import styles from "../styles/styles";

const FeaturedProductsPage = () => {
  const { allProducts = [], isLoading } = useSelector((state) => state.products);
  const INITIAL_VISIBLE = 20;
  const LOAD_MORE_STEP = 20;
  const [visibleCount, setVisibleCount] = useState(INITIAL_VISIBLE);

  const featured = useMemo(() => {
    const list = Array.isArray(allProducts) ? allProducts : [];
    return list
      .filter((p) => {
        if (p.isPromoted !== true && p.isPromoted !== "true") return false;
        const until = p.featuredUntil ? new Date(p.featuredUntil) : null;
        if (until && until <= new Date()) return false;
        return true;
      })
      .sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0));
  }, [allProducts]);

  useEffect(() => {
    setVisibleCount(INITIAL_VISIBLE);
  }, [featured.length]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div>
      <Header activeHeading={2} />
      <div className="bg-[#CCBEA1] border-t border-t-black" id="inner-page-banner">
        <div className="py-[50px] flex flex-col px-12 px-4 text-center">
          <h1 className="lg:text-4xl text-3xl md:mb-0 mb-6 lg:leading-normal font-semibold">
            Featured Products
          </h1>
          <p>
            Home &gt; <span className="text-[#38513B]">Featured Products</span>
          </p>
        </div>
      </div>

      <div className={`${styles.section} py-8`}>
        <div className="grid grid-cols-2 gap-3 sm:gap-4 md:grid-cols-2 md:gap-[20px] lg:grid-cols-4 lg:gap-[25px] xl:grid-cols-5 xl:gap-[30px] mb-12">
          {featured.slice(0, visibleCount).map((product) => (
            <ProductCard data={product} key={product._id} />
          ))}
        </div>
        {featured.length > visibleCount && (
          <div className="flex justify-center mb-10">
            <button
              type="button"
              onClick={() => setVisibleCount((prev) => prev + LOAD_MORE_STEP)}
              className="rounded-lg bg-[#38513b] px-5 py-2 text-sm font-medium text-white hover:bg-[#2f4232]"
            >
              Load more
            </button>
          </div>
        )}
        {featured.length === 0 && (
          <p className="text-center text-gray-500 pb-[100px] text-[20px]">
            No featured products at the moment.
          </p>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default FeaturedProductsPage;
